import React from 'react'
import styles from '../paymentMethod.module.css'
import { toast } from 'react-toastify'
import { FiCopy } from 'react-icons/fi'

interface PaymentMethodInstructionsProps {
  prologue: string
  buttonTitle: string
}

const PaymentMethodInstructions = ({
  prologue,
  buttonTitle
}: PaymentMethodInstructionsProps) => {
  return (
    <div className="text-dark" data-testid="orderUnpaidText">
      <span className={`text-left ${styles.removeListIndentation}`}>
        {prologue}: <br />
        <ol>
          <li>
            Send a screenshot to BigMochi WhatsApp number
            <b className="text-primary">
              {' '}
              +6580304988
              {'   '}
              <FiCopy
                onClick={() => {
                  navigator.clipboard.writeText('+6580304988')
                  toast.success('Copied!', {
                    autoClose: 3000
                  })
                }}
                className="text-primary"
              />
            </b>
            .
          </li>
          <li>
            Please click the {buttonTitle} button in order to proceed to the
            next page
          </li>
        </ol>
      </span>
    </div>
  )
}

export default PaymentMethodInstructions
